const confirmForgotPasswordEN = {
	title: "Reset your password",
	subtitle: "Enter the confirmation code we sent you and choose a new password.",
	email: "Email address",
	code: "Confirmation code",
	password: "New password",
	confirmPassword: "Confirm password",
	submit: "Reset password",
	submitting: "Updating...",
	success: "All set! Your password has been updated.",
	toast: {
		required: "Please fill in all fields to continue.",
		weakPassword:
			"Your new password needs at least 8 characters, an uppercase letter, a lowercase letter, a number, and a special character.",
		mismatch: "Those passwords don't match — give it another look.",
		invalidCode: "That code isn't valid or has expired. Please request a new one.",
		error: "We couldn't reset your password. Please try again.",
	},
};

export default confirmForgotPasswordEN;
